import React from 'react';
import { AppTabs } from 'qcc';
import { default as IndexGrid } from './IndexGrid';
import { default as IndexAdminGrid } from './IndexAdminGrid';
import './index.less'
import { UserProvider } from 'modules/User';
import api from 'api';

// let tabs: string[] = ['角色管理', '系统管理员'];
export default class extends React.Component<IPage> {
  state = { tabIndex: 0, tabs: ['角色管理'] }
  componentDidMount = async () => {
    let isAdmin = await api.appuser.isAdmin()
    let { tabs } = this.state
    if (isAdmin) {
      tabs.push('系统管理员')
    }
    this.setState({ ...tabs })
  }
  tabChg = (tabIndex: number) => {
    this.setState({ tabIndex })
  }

  render() {
    let { tabs } = this.state
    return (
      <div className='page-application-role-container'>
        <AppTabs tabs={tabs} onChange={this.tabChg}></AppTabs>
        <div className='page-role-grid-container'>
          {this.state.tabIndex === 0 ? <IndexGrid /> : <IndexAdminGrid />}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/application/role/index.tsx